
export class SampleSizeInfoModel{
   sizeId:number
   size:string
   colours:any[]
    
    constructor(
        sizeId:number,
   size:string,
   colours:any[]
    ){
       this.size = size
       this.sizeId = sizeId
       this.colours = colours
      
        }



}